/**
 * Static message exports for client-side use
 * Use this in Client Components where you need synchronous access to messages
 */

import enMessages from './messages/en.json';
import esMessages from './messages/es.json';
import ptMessages from './messages/pt.json';

export const messages = {
  en: enMessages,
  es: esMessages,
  pt: ptMessages,
} as const;

export { enMessages, esMessages, ptMessages };
